import { render, staticRenderFns } from "./FormInputSplitDate.vue?vue&type=template&id=b3c0574a&lang=pug"
import script from "./FormInputSplitDate.vue?vue&type=script&lang=ts"
export * from "./FormInputSplitDate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports